import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class ExtractedUserResidualBeneficiaryMeta extends BaseEntityModel {
  parentId?: string;
  shareOfDistribution?: number;

  constructor(model: Partial<ExtractedUserResidualBeneficiaryMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.shareOfDistribution = model.shareOfDistribution;
  }
}
